import {
    getLocalStorageReactions,
    setLocalStorageReactions,
} from "@infrastructure/Persistence/LocalUserStorage";
import { ReactionableObjectEnum } from "@infrastructure/Hooks/UserInteractions/UserInteractions.types";
import { ReactionResponse } from "@shared/Types/Reactions/ReactionTypes.types";

export function getUserReactionOnObject(
    objectId: string,
    objectType: ReactionableObjectEnum,
) {
    const userReactions = getLocalStorageReactions();
    const reaction = userReactions.find(
        (reaction) =>
            reaction.objectId === objectId &&
            reaction.objectType === objectType,
    );

    return reaction?.reactionName;
}

export function addUserReactionToObject(
    objectId: string,
    reactionName: string,
    objectType: ReactionableObjectEnum,
) {
    const userReactions = getLocalStorageReactions();
    const reaction = userReactions.find(
        (reaction) =>
            reaction.objectId === objectId &&
            reaction.objectType === objectType,
    );

    if (reaction) {
        reaction.reactionName = reactionName;
    } else {
        userReactions.push({
            reactionName: reactionName,
            objectType: objectType,
            objectId: objectId,
        });
    }

    setLocalStorageReactions(userReactions);
}

export function deleteUserReactionOnObject(
    objectId: string,
    objectType: ReactionableObjectEnum,
) {
    const userReactions = getLocalStorageReactions();
    const newReactions = userReactions.filter((item) => {
        return !(item.objectType === objectType && item.objectId === objectId);
    });

    setLocalStorageReactions(newReactions);
}

export function updateUserReactionOnObject(
    objectId: string,
    reactions: ReactionResponse,
    objectType: ReactionableObjectEnum,
) {
    if (reactions.userReactions) {
        addUserReactionToObject(
            objectId,
            reactions.userReactions[0],
            objectType,
        );
    } else {
        deleteUserReactionOnObject(objectId, objectType);
    }
}
